import React, { useEffect, useRef } from 'react';
import './index.css';
import { widget } from '../../charting_library';
import dailyDatafeed from  '../../mydatafeed/dailyDatafeed';

// }

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// async function get_datos_atr() {
// 	return
//   }

//   async function get_atr_per_day() {
// 	return true;
//   }

//   const token = localStorage.getItem("token");
//   let userType = null;
//   if (token) {
// 	const payload = parseJwt(token);
// 	userType = payload ? payload['type'] : null;
//   } else {
// 	console.error("No token found in localStorage");
//   }
  
// let userId;
// let disabledFeatures = [];
// if (userType === 'Admin') {
//     userId = 'Admin';
// } else if (userType === 'Basic') {
//     userId = 'Admin';
//     disabledFeatures = ['use_localstorage_for_settings', 'header_saveload'];
// }

const supported_resolutions =  ['1D']
export const TVChartContainer = () => {
	const chartContainerRef = useRef();
	const defaultProps = {
		symbol: 'USDCLP',
		interval: '1D',
		datafeedUrl: 'https://demo_feed.tradingview.com',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		clientId: 'https://www.qrtsolutions.com',
		// userId: userId,
		fullscreen: false,
		autosize: false,
		studiesOverrides: {},
	};
	// let arrayDatos = [];
	// let arrayATR = [];
	// Promise.all([get_datos_atr(), get_atr_per_day()])
    // .then(([datos_atr, atr_per_day]) => {
    //     arrayDatos.push(datos_atr);
    //     arrayATR.push(atr_per_day);
    // })
    // .catch(error => {
    //     console.error(error);
    // });
	
	useEffect(() => {
		const widgetOptions = {
			symbol: defaultProps.symbol,
			datafeed: dailyDatafeed,
			interval: defaultProps.interval,
			container: chartContainerRef.current,
			library_path: defaultProps.libraryPath,
			theme: "dark",
			style: "3",
			timezone: "America/Santiago",
			locale: getLanguageFromURL() || 'en',
			// disabled_features: disabledFeatures,
			enabled_features: ['study_templates'],
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			client_id: defaultProps.clientId,
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
			studies_overrides: defaultProps.studiesOverrides,
			height: '80%',
			width: '90%',
			supported_resolutions: supported_resolutions,
		};
		const tvWidget = new widget(widgetOptions);
	
		tvWidget.onChartReady(() => {
			tvWidget.applyOverrides({"mainSeriesProperties.style":3 })
				
		});
	}, []);
	
	return (
		<div
			ref={chartContainerRef}
			className={'TVChartContainer'}
		/>
	);
}
